import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async'; // <-- Import HelmetProvider
import './i18n';

import App from './App';
import './index.css';

// Create a root element
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the app inside the root with Router and HelmetProvider
root.render(
  <Router>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </Router>
);
